module.exports = __webpack_public_path__ + "images/fa-discover_offer-expired.jpg";